import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  EditButton,
  DeleteButton,
  CreateButton,
  TopToolbar,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import { createEmptyStateComponent } from '../../components/createEmptyStateComponent';

const StatusField = () => {
  const record = useRecordContext();
  if (!record?.status) {
    return null;
  }

  const getColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'success';
      case 'expired':
        return 'error';
      case 'pending':
        return 'warning';
      default:
        return 'default';
    }
  };

  return <Chip label={record.status} color={getColor(record.status)} size="small" />;
};

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

const DriverCertificationEmptyState = createEmptyStateComponent('driver-certifications');

export const DriverCertificationList = () => (
  <List
    perPage={25}
    sort={{ field: 'id', order: 'DESC' }}
    actions={<ListActions />}
    empty={<DriverCertificationEmptyState />}
  >
    <Datagrid>
      <TextField source="id" />
      <ReferenceField source="driverId" reference="drivers" link="show">
        <ReferenceField source="userId" reference="users" link={false}>
          <TextField source="name" />
        </ReferenceField>
      </ReferenceField>
      <ReferenceField source="certificationTypeId" reference="certification-types" link={false}>
        <TextField source="name" />
      </ReferenceField>
      <TextField source="otherName" />
      <DateField source="completedDate" />
      <DateField source="expiryDate" />
      <StatusField />
      <DateField source="createdAt" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);
